import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import moment from 'moment'
import Pagination from './../shared/pagination'

export default {
	name: 'deleterequest',
	components: {
		Pagination,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			orderiDS: [],
			showSelectWarehouse: false,
			listClientData: [],
			modalShow: false,
			status: '',
			WarehouseErr: '',
			showSelectClient: false,
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			warehousesearch: '',
			warehousename: '',
			orderid: '',
			listWarehouseData: [],
			clientid: '',
			ClientErr: '',
			Requesttype: '',
			Clientname: '',
			statusupdate: '',
			BoxID: '',
			tablename:'',
			whereclause:'',
			orderbyclause:'',
			isMainDB:false,
			listTableData:[],
			listDeleteRequestRows:[],
			id:'',
		    removeConfirmModel:false,
		}
	},
	computed: {

	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		var today = new Date();
		this.formattedDate = moment(today).format('YYYY-MM-DD HH:mm:ss')
		// this.getClientList()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		this.userid = userdetail.userid
		// var temp = this.useremail.split('/');
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				// this.getWarehouseList();
				// this.getClientList();

				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getClientList();

				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.showSelectClient = true;
				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		// getClientList() {
		// 	this.pageno = 0;


		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});

		// },


		changetype() {
			this.Clientname = '';
			this.orderid = '';
			this.statusupdate = '';
			this.warehousename = '';
			this.BoxID = '';
		},
		// clientSelected() {
		//
		//
		// 	if (this.user_type != 'warehouse_user') {
		// 		this.listWarehouseData = []
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		} else {
		// 			this.warehouse = ''
		// 		}
		// 	} else {
		// 		if (this.warehouseid && this.clientid);
		// 		// this.getCancelPutawayReportData();
		// 	}
		//
		//
		// },

		// clientSelected() {
		// 	this.orderid = '';
		// 	this.BoxID = '';
		// 	if (this.Clientname != this.Clientname ||this.Clientname == this.Clientname) {
		// 		this.clientid = this.Clientname;
		// 		this.listWarehouseData = []
		// 		this.warehousename = '';
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}

		// 	this.clientid = this.Clientname;
		// 	if (this.clientid) {
		// 		//this.resetaddDeatilsForm();
		// 		this.getcourierlist();
		// 		if (this.warehouseid) {
		// 			//this.getRTOListSearch();

		// 		} else {
		// 			this.getWarehouseList();

		// 		}
		// 	}
		// },



		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.Clientname,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		getDeletetableMap() {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');

				this.input = ({
					'txntype': this.Requesttype,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getDeleteTableMapping',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listTableData = result.data.data;
					}, error => {
						console.error(error)
					})
			
		},

		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},
		showRemoveModal(id) {
			this.id = id;
			this.removeConfirmModel = true;   
		},
		confirmRemove() {
			this.deleteRow(this.id);
			this.hideModal();
		  },
		  hideModal() {
			this.removeConfirmModel = false;
		  },
		
		resetaddDeatilsForm() {
			this.$validator.reset();
			this.Requesttype = '';
			this.tablename = '';
			this.whereclause ='';
			this.orderbyclause = '';
			this.isMainDB = false;
			this.listDeleteRequestRows = [];
		},
        
		async searchDeleteRequest(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			const [tableschema, tablename] = this.tablename.split(" ");
			this.isLoading = true
			this.input = ({
				'clientid':this.clientid,
				'warehouseid':this.warehouse,
				'processname': this.Requesttype,
				'tablename':tablename,
				'schemaname':tableschema,
				'whereclause':this.whereclause,
                'orderby':this.orderbyclause,
				'ismaindb':this.isMainDB ? 1 : 0
			});
			await this.$validator.validateAll().then((result) => {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'selectDataFromTable',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if(result.data.errorCode==0){
					  this.listDeleteRequestRows = result.data.data;
					  }else{
						this.listDeleteRequestRows=[]
					  }
				}, error => {
					console.error(error)
				})
			}).catch(() => {
				console.log('error exist', this.errors)
			});
		
			
		},
		async deleteRow(id){
            var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			const [tableschema, tablename] = this.tablename.split(" ");
			this.input = ({
				'clientid':this.clientid,
				'warehouseid':this.warehouse,
				'processname': this.Requesttype,
				'tablename':tablename,
				'schemaname':tableschema,
				'ismaindb':this.isMainDB ? 1 : 0,
				'id':id,
				"useremail":this.useremail
			});
			this.isLoading = true
			await this.$validator.validateAll().then((result) => {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteDataFromTable',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if(result.data.errorCode == 0){
						this.$alertify.success(result.data.msg)
						this.searchDeleteRequest()
						this.isLoading = false
					}else{
						this.$alertify.error(result.data.msg)
						this.isLoading = false
					}
				}, error => {
					console.error(error)
				})
			}).catch(() => {
				console.log('error exist', this.errors)
			});
		
		}

	},
}



// WEBPACK FOOTER //
// ./src/views/components/deleterequest/deleterequest.component.js